import { type IFirestoreModel } from '../firebase/firestore/model';
import { BaseMock } from './base-mock';
import { type Properties } from './base-mock-types';
import { MockTimestamp } from './mock-helpers';

export class BaseFirestoreMock<TInterface>
  extends BaseMock<TInterface>
  implements Properties<IFirestoreModel>
{
  createdAt = MockTimestamp();
  updatedAt = MockTimestamp();
  deleted = false;
}

export function MockBaseFirestore(): IFirestoreModel {
  return {
    createdAt: MockTimestamp(),
    updatedAt: MockTimestamp(),
    deleted: false,
  };
}
